<template>
  <div class="window-cleaning-container">
    <div class="service-list">
      <h2 class="section-title">Перечень работ</h2>
      <ul class="service-list-items">
        <li v-for="(task, index) in currentTasks" :key="index" :class="{ 'category-title': isCategory(task) }">
          <span class="check-icon" v-if="!isCategory(task)">✔️</span>
          <span :class="{ 'highlighted-text': isCategory(task) }">{{ task }}</span>
        </li>
      </ul>
    </div>

    <div class="window-list">
      <div class="window-cleaning-container__title">
        <h2 class="section-title purple-color">МЫТЬЕ ОКОН</h2>
        <div class="wrap-cost">
          <p class="wrap-cost__text">Ставка: {{ getRate() }} руб./кв.м</p>
        </div>
      </div>

      <!-- Переключатели -->
      <div class="wrap-toggle-container">
        <div class="wrap-toggle-container__block">
          <div class="radio-group-title">Тип уборки:</div>
          <div class="pill-tabs">
            <div
                :class="['pill-tab', { active: cleaningMode === 'season' }]"
                @click="cleaningMode = 'season'">Сезонное мытье</div>
            <div
                :class="['pill-tab', { active: cleaningMode === 'after' }]"
                @click="cleaningMode = 'after'">После ремонта</div>
          </div>

        </div>
        <div class="pill-group">
          <div class="radio-group-title">Тип окон:</div>
          <div class="pill-tabs">
            <div
                :class="['pill-tab', { active: windowType === 'standard' }]"
                @click="windowType = 'standard'">
              Стандартные
            </div>
            <div
                :class="['pill-tab', { active: windowType === 'nonstandard' }]"
                @click="windowType = 'nonstandard'">
              Нестандартные
            </div>
          </div>
        </div>
      </div>

      <!-- Слайдер -->
      <div class="slider-wrapper">
        <div
            class="slider-tooltip"
            ref="tooltip"
            :style="{ left: tooltipLeft + 'px' }"
        >
          {{ squareMeters }} кв.м
        </div>

        <input
            ref="slider"
            type="range"
            class="slider"
            min="40"
            max="200"
            :value="squareMeters"
            @input="updateSlider"
        />

        <div class="slider-range">
          <span class="range-label">40 кв.м</span>
          <span class="range-label">200 кв.м</span>
        </div>
      </div>
      <!-- Дополнительные услуги -->
      <h3 class="section-subtitle">Дополнительные услуги</h3>
      <div class="services-grid">
        <label v-for="(service, index) in currentServices" :key="index" class="checkbox-card">
          <input type="checkbox" v-model="selectedServices" :value="service" />
          <span class="checkbox-indicator"></span>
          <span class="service-label">{{ service.name }} — {{ service.price }} руб.</span>
        </label>
      </div>

      <!-- Итого -->
<!--      <div class="wrap-total-cost">-->
<!--        <p class="total-cost">ИТОГО: {{ calculateTotalCost() }} руб.</p>-->
<!--      </div>-->

      <div class="wrap-total-cost">
        <template v-if="isFirstOrderDiscount">
          <p class="total-cost discount">
            ИТОГО: {{ totalWithoutDiscount }} руб.
          </p>
          <p class="total-cost discount-color">
            СО СКИДКОЙ: {{ calculateTotalCost() }} руб.
          </p>
        </template>
        <template v-else>
          <p class="total-cost">ИТОГО: {{ calculateTotalCost() }} руб.</p>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "AppWindowCleaning",
    props: {
      squareMeters: {
        type: Number,
        required: true
      },
    },
    emits: ['update:squareMeters'],
    data() {
      return {
        cleaningMode: "season", // season | after
        windowType: "standard", // standard | nonstandard
        // squareMeters: 60,
        selectedServices: [],
        tooltipLeft: 0,
        discountService: { name: "Мой первый заказ, скидка 10%", price: 0 },
        services: {
          season: {
            standard: [
              { name: "Остекление стандартного балкона + дверь", price: 920 },
              { name: "Остекление нестандартного балкона + дверь", price: 1100 },
              { name: "Имеется второй балкон", price: 1100 },
              { name: "Оконные решетки (1 створка)", price: 250 },
              { name: "Мытье жалюзи (1 створка)", price: 250 }
            ],
            nonstandard: [
              { name: "Остекление стандартного балкона + дверь", price: 920 },
              { name: "Остекление нестандартного балкона + дверь", price: 1100 },
              { name: "Имеется второй балкон", price: 1100 },
              { name: "Оконные решетки (1 створка)", price: 250 },
              { name: "Мытье жалюзи (1 створка)", price: 250 }
            ]
          },
          after: {
            standard: [
              { name: "Остекление стандартного балкона + дверь", price: 1100 },
              { name: "Остекление нестандартного балкона + дверь", price: 1500 },
              { name: "Имеется второй балкон", price: 1500 },
              { name: "Оконные решетки (1 створка)", price: 250 },
              { name: "Мытье жалюзи (1 створка)", price: 250 }
            ],
            nonstandard: [
              { name: "Остекление стандартного балкона + дверь", price: 1380 },
              { name: "Остекление нестандартного балкона + дверь", price: 1680 },
              { name: "Имеется второй балкон", price: 1500 },
              { name: "Оконные решетки (1 створка)", price: 250 },
              { name: "Мытье жалюзи (1 створка)", price: 250 }
            ]
          }
        },

        taskMap: {
          season: [
            "СЕЗОННОЕ МЫТЬЕ ОКОН:",
            "Мытье окон с двух сторон",
            "Очищение москитных сеток*",
            "*демонтирует и устанавливает заказчик",
            "Мытье откосов, отливов",
            "Мытье рам, фурнитуры",
            "Мытье подоконников"
          ],
          after: [
            "МЫТЬЕ ОКОН ПОСЛЕ РЕМОНТА:",
            "Мытье окон с двух сторон",
            "Очищение москитных сеток*",
            "*демонтирует и устанавливает заказчик",
            "Мытье откосов, отливов",
            "Мытье рам, фурнитуры",
            "Мытье подоконников",
            "Удаление следов краски, строительных смесей, клея"
          ]
        }
      };
    },
    watch: {
      cleaningMode(val) {
        this.$emit('update:isAfter', val === 'after');
      },
      windowType(val) {
        this.$emit('update:isStandard', val === 'standard');
      }
    },
    computed: {
      // currentServices() {
      //   return this.services[this.cleaningMode][this.windowType];
      // },
      currentServices() {
        const baseServices = this.services[this.cleaningMode][this.windowType];
        // Добавляем чекбокс скидки в начало списка
        return [this.discountService, ...baseServices];
      },
      isFirstOrderDiscount() {
        return this.selectedServices.includes(this.discountService);
      },
      totalWithoutDiscount() {
        const base = this.squareMeters * this.getRate();
        const extra = this.selectedServices
            .filter(s => s !== this.discountService)
            .reduce((sum, s) => sum + s.price, 0);
        return base + extra;
      },
      currentTasks() {
        return this.taskMap[this.cleaningMode];
      }
    },
    methods: {
      updateSlider(e) {
        this.$emit('update-square-meters', Number(e.target.value));
      },
      updateTooltipPosition() {
        const sliderEl = this.$refs.slider;
        const tooltipEl = this.$refs.tooltip;

        if (!sliderEl || !tooltipEl) return;

        const min = Number(sliderEl.min);
        const max = Number(sliderEl.max);
        const percent = (this.squareMeters - min) / (max - min);

        const sliderWidth = sliderEl.offsetWidth;
        const tooltipWidth = tooltipEl.offsetWidth;

        // вычисляем смещение
        let left = sliderWidth * percent - tooltipWidth / 2;

        // 🔒 ограничим только СЛЕВА, минимум 10px
        this.tooltipLeft = Math.max(left, 10);
      },
      getRate() {
        const isAfter = this.cleaningMode === "after";
        const isStandard = this.windowType === "standard";
        const sqm = this.squareMeters;

        if (isAfter) {
          if (isStandard) return sqm >= 100 ? 50 : 80;
          else return 90;
        } else {
          if (isStandard) return sqm >= 100 ? 50 : 60;
          else return 80;
        }
      },
      // calculateTotalCost() {
      //   const base = this.squareMeters * this.getRate();
      //   const extra = this.selectedServices.reduce((sum, item) => sum + item.price, 0);
      //   return base + extra;
      // },
      // calculateTotalCost() {
      //   const base = this.squareMeters * this.getRate();
      //   const extra = this.selectedServices
      //       .filter(s => s !== this.discountService)
      //       .reduce((sum, item) => sum + item.price, 0);
      //   return base + extra;
      // },
      calculateTotalCost() {
        const total = this.totalWithoutDiscount;
        return this.isFirstOrderDiscount ? Math.round(total * 0.9) : total;
      },
      isCategory(task) {
        return task.endsWith(":");
      }
    },
    mounted() {
      this.updateTooltipPosition();
      window.addEventListener('resize', this.updateTooltipPosition);
    },
    updated() {
      this.updateTooltipPosition();
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.updateTooltipPosition);
    },
  };
</script>


<style scoped>
.pill-group {
  margin-bottom: 30px;
}

.pill-tabs {
  display: inline-flex;
  background: #f1f1f1;
  border-radius: 9999px;
  padding: 4px;
  transition: background-color 0.3s ease;
}

.pill-tab {
  padding: 10px 20px;
  border-radius: 9999px;
  cursor: pointer;
  font-weight: 500;
  font-size: 16px;
  color: #555;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
  background-color: transparent;
  transition: background-color 0.3s ease, color 0.3s ease;
}

.pill-tab.active {
  background-color: #4A68F3;
  color: white;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
}
.window-cleaning-container {
  padding: 30px;
  background-color: #fff;
  border-radius: 16px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.05);
  display: flex;
  gap: 30px;
  width: 100%;
}
.service-list {
  flex: 30%;
  border-right: 3px solid rgba(74, 104, 243, 0.2);
  box-shadow: 8px 0 12px -10px rgba(74, 104, 243, 0.2);
  padding: 0px 20px 0px 0px;
}
.window-list {
  flex: 70%;
}
.window-cleaning-container__title {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.wrap-cost {
  margin: 0px 0px 0px 20px;
  background: #f154bb;
  border-radius: 50px ;
  padding: 10px 20px;
  text-align: center;
}

.wrap-cost__text {
  font-weight: 700;
  font-size: 20px;
  color: white;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
}
.section-title {
  font-size: 36px;
  font-weight: 600;
  text-transform: uppercase;
  color: #333;
  margin-bottom: 15px;
}
.section-title-mini {
  font-size: 24px;
  font-weight: 600;
  text-transform: uppercase;
  color: #333;
  margin-bottom: 15px;
}
.service-list-items {
  list-style-type: none;
  padding-left: 0;
  color: #555;
}
.service-list-items li {
  padding: 5px 0px;
}
.wrap-toggle-container {
  display: flex;
  margin-bottom: 75px;
}
.wrap-toggle-container__block {
  margin-right: 60px;
}

.radio-group-title {
  font-weight: 600;
  margin-top: 16px;
  margin-bottom: 8px;
  color: #333;
  font-size: 16px;
}

.toggle-buttons {
  display: flex;
  gap: 12px;
  margin-bottom: 12px;
}

.toggle-buttons button {
  background-color: #f1f1f1;
  border: none;
  padding: 10px 16px;
  border-radius: 30px;
  font-weight: 500;
  cursor: pointer;
  color: #333;
  transition: 0.3s;
}

.toggle-buttons button.active {
  background-color: #4A68F3;
  color: white;
}
.slider-wrapper {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}
.category-title {
  font-weight: 700;
  font-size: 18px;
  color: #4A68F3;
  margin-top: 10px;
  margin-bottom: 10px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
}
.highlighted-text {
  font-weight: bold;
  color: #333;
  position: relative;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
}

.slider-tooltip {
  position: absolute;
  top: -75px;
  background-color: #4A68F3;
  color: #ffffff;
  padding: 8px 25px;
  border-radius: 30px;
  font-size: 16px;
  font-weight: 600;
  white-space: nowrap;
  transform: translateX(-50%);
  transition: left 0.3s ease;
}

.slider {
  -webkit-appearance: none;
  width: 100%;
  height: 15px;
  background-color: #e0e0e0;
  border-radius: 5px;
  outline: none;
  transition: background-color 0.3s ease;
}

.slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  width: 45px;
  height: 45px;
  background-color: #4A68F3;
  border-radius: 50%;
  cursor: pointer;
  box-shadow: 0px 4px 8px rgba(74, 104, 243, 0.3);
}
.slider-range {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 8px;
}
.range-label {
  font-size: 24px;
  font-weight: 600;
  color: #333;
}
.rate-info {
  font-size: 16px;
  font-weight: 500;
  color: #333;
  margin-bottom: 20px;
}

.section-subtitle {
  font-size: 20px;
  font-weight: 600;
  margin: 20px 0 12px;
  color: #333;
}

.services-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.checkbox-card {
  display: flex;
  align-items: center;
  background-color: #f9f9f9;
  border-radius: 12px;
  padding: 10px 16px;
  gap: 12px;
  position: relative;
  font-size: 15px;
  color: #333;
  transition: 0.2s;
  cursor: pointer;
}

.checkbox-card:hover {
  background-color: #f0f0f0;
}

.checkbox-card input {
  display: none;
}

.checkbox-indicator {
  min-width: 20px;
  height: 20px;

  position: relative;
  background-color: #fff;
  border: 2px solid #4A68F3;
  border-radius: 4px;
}

.checkbox-card input:checked + .checkbox-indicator {
  background-color: #4A68F3;
}

.checkbox-card input:checked + .checkbox-indicator::after {
  content: "";
  position: absolute;
  left: 5px;
  top: 1px;
  width: 6px;
  height: 12px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.wrap-total-cost {
  margin-top: 30px;
  text-align: right;
}

.total-cost {

    font-size: 45px;
    font-weight: bold;
    color: #4A68F3;

}
@media (max-width: 1024px) {
  .radio-group-title {

    margin-top: 10px;
    margin-bottom: 10px;

  }
  .window-cleaning-container__title {

    align-items: start;
    flex-direction: column;
  }
  .wrap-toggle-container {
    flex-direction: column;
    margin-bottom: 35px;
  }
  .wrap-toggle-container__block {
    margin-right: 0px;
  }

  .wrap-total-cost {
    margin-top: 20px;
  }
  .wrap-cost {
    margin: 10px 0px 5px 0px;
  }
  .section-title {
    font-size: 20px;
    margin-bottom: 0px;
  }
  .wrap-cost__text {
    font-size: 12px;
  }
  .section-title-mini {
    font-size: 16px;
  }
  .total-cost {
    font-size: 24px;
  }
}
@media (max-width: 768px) {
  .total-cost {
    font-size: 20px;
  }
  .slider-tooltip {
    top: -55px;
    font-size: 14px;
    padding: 6px 16px;
  }

  .slider {
    height: 12px;
  }
  .pill-tab {
    font-size: 12px;
  }

  .slider::-webkit-slider-thumb {
    width: 30px;
    height: 30px;
  }

  .slider-range {
    margin-top: 4px;
  }

  .range-label {
    font-size: 16px;
  }

  .services-grid {
    grid-template-columns: 1fr; /* по одной колонке */
    gap: 8px;
  }



  .checkbox-container input:checked ~ .custom-checkbox::after {
    font-size: 12px;
    left: 4px;
    top: -1px;

  }
  .service-list {
    display: none ;
  }
}

</style>
